import { Modal, Button, Alert, Row, Col, ControlLabel } from 'react-bootstrap';
import { IUser } from '@nkr/models/index';
import { menuItemList, UserAction } from './action-button-renderer';

interface IProps {
    show: boolean,
    data: IUser,
    action: UserAction,
    onConfirm: () => void,
    onCancel: () => void
}

const ConfirmUserDelete = (props: IProps) => {
    const getTitle = () => {
        let action = menuItemList.find(x => x.action == props.action);
        return action?.title;
    };

    const title = getTitle();
    const firstName = props.data != null ? props.data.firstName : '';
    const lastName = props.data != null ? props.data.lastName : '';
    const email = props.data != null ? props.data.email : '';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm {title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle={props.action == UserAction.Delete ? 'danger' : 'warning'} bsSize='sm'>
                    {props.action == UserAction.Delete && (
                        <>Are you sure you want to delete the following user?</>
                    )}

                    {props.action == UserAction.ActivatePasswordExpiration && (
                        <>Confirm you would like to activate the password expiration for the following user:</>
                    )}

                    {props.action == UserAction.DeactivatePasswordExpiration && (
                        <>Confirm you would like to deactivate the password expiration for the following user:</>
                    )}

                    {props.action == UserAction.UnlockUser && (
                        <>Confirm you would like to unlock the following user:</>
                    )}

                    {props.action == UserAction.LockoutUser && (
                        <>Confirm you would like to lockout the following user:</>
                    )}

                    {props.action == UserAction.ClearBlocks && (
                        <>Confirm you would like to clear the blocks for the following user:</>
                    )}
                </Alert>

                <div className='container-fluid' style={{ marginLeft: 10 }}>
                    <Row>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>First Name</Col>
                        <Col xs={12} lg={6}>
                            {firstName}
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Last Name</Col>
                        <Col xs={12} lg={6}>
                            {lastName}
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Email</Col>
                        <Col xs={12} lg={6}>
                            {email}
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle={props.action == UserAction.Delete ? 'danger' : 'warning'} onClick={props.onConfirm}>Yes</Button>
                <Button onClick={props.onCancel}>No</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmUserDelete;